(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    /* MP Drawer Utilities */
  document.addEventListener('DOMContentLoaded', () => {
    /* Currency button opens drawer localization submenu */
    const currencyBtn = document.querySelector('[data-mp-drawer-currency-trigger]');
    if (currencyBtn) {
      currencyBtn.addEventListener('click', () => {
        const drawerLocalization = document.querySelector('#drawer-localization');
        if (drawerLocalization) {
          const summary = drawerLocalization.querySelector('summary');
          if (summary) summary.click();
        }
      });
    }

    /* Helper: close the drawer menu */
    function closeDrawer() {
      const closeBtn = document.querySelector('.mp-drawer-header__close');
      if (closeBtn) closeBtn.click();
    }

    /* Search button: close drawer, then open search modal */
    const searchBtn = document.querySelector('[data-mp-open-search]');
    if (searchBtn) {
      searchBtn.addEventListener('click', () => {
        closeDrawer();
        setTimeout(() => {
          const searchModal = document.getElementById('search-modal');
          if (searchModal && typeof searchModal.showDialog === 'function') {
            searchModal.showDialog();
          }
        }, 350);
      });
    }

    /* Account button: close drawer, then open account dialog */
    const accountBtn = document.querySelector('[data-mp-open-account]');
    if (accountBtn) {
      accountBtn.addEventListener('click', () => {
        closeDrawer();
        setTimeout(() => {
          const accountDrawerComponent = document.querySelector('dialog-component.account-drawer');
          if (accountDrawerComponent && typeof accountDrawerComponent.showDialog === 'function') {
            accountDrawerComponent.showDialog();
          }
        }, 350);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
